import type { SearchQueryBody } from "@/types";

/**
 * TanStack-Query key factory for session-list reads. The hierarchy
 * `all` ⊃ `lists()` ⊃ `list(orgId, query)` lets mutations invalidate at
 * the broadest level they affect. Mirrors `eventQueryKeys`.
 */
export const sessionQueryKeys = {
  all: ["sessions"] as const,
  lists: () => [...sessionQueryKeys.all, "list"] as const,
  // Omit the `query` slot rather than appending `undefined`, so callers
  // that pass no body share a cache slot.
  list: (orgId: string | undefined, query?: SearchQueryBody) =>
    query
      ? ([...sessionQueryKeys.lists(), orgId, query] as const)
      : ([...sessionQueryKeys.lists(), orgId] as const),
};
